import { jsonldUrl } from './JsonldStore';

export const updateJsonldUrl = (value) => jsonldUrl.update((oldValue) => value);
